fragment OrderVoucherFull on OrderVoucher {
  id
  generatedVoucherId
  orderVoucherProduct {
    id
    name {
      ...LocalizedStringFull
    }
    value
  }
  quantity
}
